import { NsType, ReactOptions, TranslationKey, useTolgee, useTranslate } from '@tolgee/react';
import { tolgee as originTolgee } from '../index';
import { defaultLanguage } from '../../../../@controls/utils';

export const useToolTranslation = (ns?: NsType[] | string, options?: ReactOptions) => {
  const tolgee = useTolgee();
  const { t: tTolgee, ...everythingElse } = useTranslate(ns, options);
  const _t = (key: TranslationKey, options?: any, defaultValue?: string) => {
    if (key.includes(':')) {
      const [namespace, _key] = key.split(':');
      return tTolgee({
        key: _key,
        params: options,
        ...options,
        ns: namespace,
      });
    }
    return tTolgee({
      key: key,
      params: options,
      defaultValue: defaultValue,
    });
  };
  return {
    t: _t,
    i18n: {
      ...originTolgee,
      language: tolgee.getLanguage() || defaultLanguage,
    },
    tolgee: tolgee,
    changeLanguage: (lang: string) => {
      tolgee.changeLanguage(lang);
    },
    ...everythingElse,
  };
};
